import Button from "@/components/ui/button.tsx";
import Icon from "@/components/ui/icon";

type Props = { onZoomIn: () => void; onZoomOut: () => void };
export default function CustomControls({ onZoomIn, onZoomOut }: Props) {
    return (
        <div className="model-renderer__zoom-controls">
            <Button variant="icon" className="model-renderer__zoom-control" onClick={onZoomOut}>
                <Icon name="minus" />
            </Button>
            <Button variant="icon" className="model-renderer__zoom-control" onClick={onZoomIn}>
                <Icon name="plus" />
            </Button>
        </div>
    );
}
